export type PickupCodeSubmission = {
  pickupCode: string | null;
  notes: string | null;
};

function withoutPickupCodeNote(notes?: string | null): string | null {
  if (!notes) return null;

  const redacted = notes
    .replace(/(?:^|\s*)Pickup code:\s*\d+\s*/gi, " ")
    .replace(/\s{2,}/g, " ")
    .trim();

  return redacted || null;
}

/**
 * Keep client-generated pickup material out of every code-less attendance path.
 * The database independently re-evaluates the same context on replay.
 */
export function getPickupCodeSubmission({
  pickupCodeContext,
  pickupCode,
  notes,
}: {
  pickupCodeContext: boolean;
  pickupCode?: string | null;
  notes?: string | null;
}): PickupCodeSubmission {
  const normalizedPickupCode = pickupCode?.trim() || null;

  if (!pickupCodeContext || !normalizedPickupCode) {
    return {
      pickupCode: null,
      notes: withoutPickupCodeNote(notes),
    };
  }

  return {
    pickupCode: normalizedPickupCode,
    notes: notes ?? `Pickup code: ${normalizedPickupCode}`,
  };
}
